const PanelistCard = ({ panelist, position, animationDirection }) => {
	const isModerator = panelist.role === 'Moderator';

	const cardHeightClass =
		position === 1
			? 'h-80 w-72 lg:h-96 lg:w-96 z-20 bg-bgColor border border-bgColor'
			: position === 0 || position === 2
			? 'h-72 z-10 bg-bgColor text-sm border border-bgColor'
			: 'h-64 z-5 bg-bgColor text-sm border border-bgColor';

	const transformValue = animationDirection === 'left' ? '-1%' : '8%';
	const gradientColor = isModerator ? 'via-white/40' : 'via-orange-600/40';
	const roleColor = isModerator ? 'text-white' : position === 1 ? 'text-speakerTextBrown' : 'text-speakerTextBlue';

	return (
		<div
			className={`relative overflow-hidden w-56 p-4 rounded-lg shadow-md ${cardHeightClass} flex transition-transform`}
			style={{
				transform: `translateX(${transformValue})`,
				transition: 'transform 0.8s ease-in-out',
			}}
		>
			<div className={`${position === 2 ? 'text-white' : 'text-white'} h-full`}>
				<div className={`relative ${roleColor}`}>
					{isModerator && position === 1 && (
						<span className="inline-block bg-white text-black text-xs font-bold px-3 py-1 rounded-full mb-2">
							{panelist.role}
						</span>
					)}
					<p>{panelist.position}</p>
				</div>
				<h2 className={`font-semibold w-5 mt-2 ${position === 1 ? 'text-4xl' : 'text-lg'}`}>
					{panelist.name}
				</h2>
			</div>
			<div
				className={`absolute right-0 ${
					position === 1 ? '-bottom-16 w-56 h-56 lg:w-72 lg:h-72' : '-bottom-5 w-48 h-48'
				}`}
			>
				<div
					className={`absolute inset-0 bg-gradient-to-l from-transparent ${gradientColor} to-transparent rounded-full`}
				/>
			</div>
			<img
				src={panelist.imageURL}
				alt={panelist.name}
				loading="lazy"
				className={`absolute bottom-0 right-0 object-cover ${isModerator ? '' : 'rounded-full'}`}
				style={{
					width: position === 1 ? '250px' : '150px',
					height: position === 1 ? '250px' : '150px'
				}}
			/>
		</div>
	);
};

export default PanelistCard;
